import { Route, Redirect } from 'react-router-dom';

import { user } from 'services';

/**
 * private route
 *
 * @param {*} param0
 */
export const RoutePrivate = ({ component: Component, params, defaultPath, ...rest }) => {
  if (!user.isLogined) {
    const url = '/auth';
    return <Redirect to={url} />;
  } else {
    if (rest.path === '/scheme') {
      return <Redirect to={defaultPath} />;
    }

    return <Route {...rest} render={(props) => <Component {...props} {...params} />} />;
  }
};
